/**
 * 現在のスクロール位置を{x, y}の形式で取得します。
 *
 * @returns {Object} 現在のスクロール位置。{x: number, y: number}の形式。
 */
export function getPageScroll() {
    const xScroll = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
    const yScroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    return { x: xScroll, y: yScroll };
}
